import { Injectable } from '@angular/core';
import { Resource } from '../core/state/resource/models';
import { CourseCategory } from '../core/state/course/models';

@Injectable({
  providedIn: 'root'
})
export class FormatterService {
  getResourceImagePath(resource?: Resource | string | null): string {
    if (resource && typeof resource !== 'string') {
      return resource.path || '';
    }
    return '';
  }

  getCategoryName(category?: CourseCategory | string | null): string {
    if (category && typeof category !== 'string') {
      return category.name || '';
    }
    return '';
  }

  formatDuration(minutes: number | undefined): string {
    if (!minutes) return 'Flexible';
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    if (hours === 0) return `${remainingMinutes} min`;
    return remainingMinutes === 0 ? `${hours} hr` : `${hours} hr ${remainingMinutes} min`;
  }
} 